import { Component, OnInit } from '@angular/core'
import { DataPageOfManageRoles, ManageRoles } from '../../../../api/models'
import { RolesService } from '../../../../api/services'
import { Router, ActivatedRoute } from '@angular/router'
import { MessageService, ConfirmationService, LazyLoadEvent } from 'primeng/api'

@Component({
  selector: 'app-roles-list',
  templateUrl: './roles-list.component.html',
  styleUrls: ['./roles-list.component.css'],
})
export class RolesListComponent implements OnInit {
  cols: { field: string; header: string }[]
  rows: number
  roles: DataPageOfManageRoles
  selectedRole: ManageRoles
  Showrecords: boolean
  currentPage: number = 1
  first: number = 0 // Variable to track the first record

  constructor(
    private rolesservice: RolesService,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private confirmation: ConfirmationService,
  ) {}

  ngOnInit(): void {
    this.cols = [
      { field: 'roleName', header: 'Role Name' },
      { field: 'roleDescription', header: 'Role Description' },
    ]

    this.loadRolesList(1, '', '')
  }

    loadRolesList(pageNumber: number, sortcolumn: string, sortorder: string) {
        this.first = pageNumber;
    this.rolesservice
      .rolesList({
        pageNumber: pageNumber,
      })
        .subscribe((Result) => {
        this.roles = Result
            this.rows = this.roles.pageSize;

        if (this.roles.totalRecords > 0) {
          this.Showrecords = true
        } else {
          this.Showrecords = false
        }
      })
  }
  createRoles() {
    this.router.navigate(['administration/upsert-roles'], {
      queryParams: { role_Id: -1 },
      skipLocationChange: true,
    })
  }

  onEdit(rowData) {
    this.router.navigate(['administration/upsert-roles'], {
      queryParams: { role_Id: rowData.roleId },
      skipLocationChange: true,
    })
  }

  dropRole(event: Event, roleId: number) {
    debugger
    if (event.defaultPrevented) return
    event.preventDefault()

    this.confirmation.confirm({
      key: 'delete_confirmation',
      message: 'Are you sure you want to delete this Role?',
      accept: () => {
        this.onDeleteRole(roleId)
      },
    })
  }

  onDeleteRole(id: number): void {
    debugger
    this.rolesservice.rolesDelete({ Roleid: id }).subscribe((result) => {
      if (result.status.toLowerCase().indexOf('error') > -1) {
        this.messageService.add({
          key: 'alertToast',
          severity: 'error',
          detail: result.message,
          summary: 'ERROR',
          life: 7000,
        })
      } else if (result.status.toLowerCase().indexOf('ok') > -1) {
        this.messageService.add({
          key: 'alertToast',
          severity: 'success',
          detail: result.message,
          summary: 'Confirmation',
          life: 7000,
        })

        this.loadRolesList(1, '', '')
      }
    })
  }

  nextPage($event: LazyLoadEvent) {
    debugger
    console.log($event)
    let nextPage = $event.first / $event.rows + 1
    var order = 'Asc'
    if ($event.sortOrder == -1) {
      order = 'Desc'
    }
    if ($event.first == 0) {
        this.loadRolesList(1, $event.sortField, order)
      //this.currentPage = 1;
    } else {
        this.loadRolesList(nextPage, $event.sortField, order)

      //this.currentPage = nextPage;
    }

    this.currentPage = Math.floor($event.first / $event.rows) + 1
  }
}
